const SiteSearchConstants = {
  searchBarId: 'emporiSearchBar',
  searchTriggerId: 'emporiSearchTrigger'
}

export function initMobileUi() {
  const searchBar = document.getElementById(SiteSearchConstants.searchBarId);
  const trigger = document.getElementById(SiteSearchConstants.searchTriggerId);
  
  if (!trigger || !searchBar) {
    return;
  }

  const cls = 'visible';
  let triggered = false;
  let lastScroll = window.scrollY;

  trigger.addEventListener('click', () => {
    if (!triggered) {
      searchBar.classList.add(cls);
      triggered = true;

      const input = searchBar.querySelector('input');

      if (input) {
        input.focus();
      }

      return;
    }

    if (window.scrollY > searchBar.clientHeight) {
      searchBar.classList.remove(cls);
    }

    triggered = false;
  });

  function setCls(currentY: number, lastY: number) {
    if (!trigger || !searchBar) {
      return;
    }
    
    if (lastY > currentY) {
      searchBar.classList.add(cls);
      return;
    }

    if (currentY > searchBar.clientHeight && !searchBar.querySelector('.clear-search')) {
      searchBar.classList.remove(cls);
      triggered = false;
      return;
    }

    searchBar.classList.add(cls);
  }

  window.addEventListener('scroll', () => {
    const { scrollY } = window;

    setCls(scrollY, lastScroll);
    lastScroll = scrollY;
  });
}